import { render, staticRenderFns } from "./InfoButtonTogglePopover.vue?vue&type=template&id=3a0aa36b"
import script from "./InfoButtonTogglePopover.vue?vue&type=script&lang=js"
export * from "./InfoButtonTogglePopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports